/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanProductAccountSettingItemOutputDto { 
    id?: number;
    accountId?: number;
    accountingCode?: string | null;
    accountName?: string | null;
    accountNumber?: string | null;
    chargeType?: string | null;
    ledgerType?: string | null;
}

